module.exports = __webpack_public_path__ + "img/discuss-screen-es.ea3a972e.webp";